import { Stack, Typography, Button } from '@mui/material'
import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import { useDemoModeContext } from '@/components/demo-mode-provider/DemoModeProvider'

export default function DemoModeInfo() {
  const isSuperUser = useIsSuperUser()
  const [demoMode, setDemoMode] = useDemoModeContext()
  const isProd = import.meta.env.VITE_ENVIRONMENT === 'prod'

  return !isProd || (isSuperUser && !demoMode) ? (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{
        border: (theme) => `1px solid ${theme.palette.secondary.main}`,
        borderRadius: '4px',
        px: 1,
      }}
    >
      {!isProd && (
        <Typography
          sx={{ textTransform: 'uppercase', fontSize: '13px' }}
          color="neutral"
        >
          {import.meta.env.VITE_ENVIRONMENT}
        </Typography>
      )}
      {isSuperUser && !demoMode && (
        <>
          {!isProd && (
            <Typography sx={{ pl: 0.75 }} color="neutral">
              •
            </Typography>
          )}
          <Button onClick={() => setDemoMode(true)} variant="text">
            Turn On Demo Mode
          </Button>
        </>
      )}
    </Stack>
  ) : null
}
